function getNextSlideIndex({ currentIndex, slideCount, direction }) {
  const lastSlideIndex = Math.max(0, slideCount - 1)
  return Math.min(lastSlideIndex, Math.max(0, currentIndex + Math.sign(direction)))
}

function getSwipeDirection({ startX, startY, endX, endY, minDistance = 48 }) {
  const horizontalDistance = endX - startX
  const verticalDistance = startY - endY

  if (Math.abs(verticalDistance) < minDistance || Math.abs(verticalDistance) <= Math.abs(horizontalDistance)) {
    return 0
  }

  return Math.sign(verticalDistance)
}

module.exports = {
  getNextSlideIndex,
  getSwipeDirection
}
